import { Card, CardHeader, CardPreview, Image, makeStyles, Text, Title2 } from "@fluentui/react-components";
import IAward from "../../../models/award/IAward";

const useStyles = makeStyles({
    card: {
        maxWidth: "300px",
        width: "100%",
        paddingTop: "1rem",
        paddingBottom: "1.5rem",
        cursor: "pointer",
        transition: "transform 0.2s",

        "&:hover": {
            transform: "translateY(-5px)"
        },

        "@media (max-width: 768px)": {
            maxWidth: "100%",
        }
    },
    image: {
        marginTop: "auto !important",
    },
    header: {
        marginTop: "auto !important",
        marginBottom: "0"
    }
});

interface IAwardProps {
    award: IAward;
    onClick: (award: IAward) => void;
}

export default function Award(props: IAwardProps) {
    const award = props.award;
    const styles = useStyles();

    const title = <Title2 as="h2">{award.name}</Title2>,
        description = <Text>{getDescription(award.description)}...</Text>,
        image = award.logo || award.image;

    return (
        <Card className={styles.card} onClick={() => props.onClick(award)}>
            <CardPreview className={styles.image}>
                <Image src={image.url} alt={image.altText} />
            </CardPreview>
            <CardHeader
                header={title}
                description={description}
                className={styles.header}
                />
        </Card>
    );
}

function getDescription (description: string) {
    const parser = new DOMParser();
    const plainTextDescription = parser.parseFromString(description, "text/html").body.textContent || "";
    
    return plainTextDescription.substring(0, 90);
}